function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var NewWorldTemplate = require('./newworld.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var NewWorldOverlay = /*#__PURE__*/function () {
  function NewWorldOverlay(app, mod) {
    _classCallCheck(this, NewWorldOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(NewWorldOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var round = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var his_self = this.mod;
      if (round == 0) {
        round == his_self.game.state.round;
      }
      for (var z = 0; z < his_self.game.state.colonies.length; z++) {
        if (his_self.game.state.colonies[z].round > round) {
          round = his_self.game.state.colonies[z].round;
        }
      }
      for (var _z = 0; _z < his_self.game.state.conquests.length; _z++) {
        if (his_self.game.state.conquests[_z].roundd > round) {
          round = his_self.game.state.conquests[_z].round;
        }
      }
      for (var _z2 = 0; _z2 < his_self.game.state.explorations.length; _z2++) {
        if (his_self.game.state.explorations[_z2].round > round) {
          round = his_self.game.state.explorations[_z2].round;
        }
      }
      this.visible = true;
      this.overlay.show(NewWorldTemplate(this.mod));
      var active_colonies = 0;
      var active_conquests = 0;
      var active_explorations = 0;

      //////////////
      // COLONIES //
      //////////////
      for (var _z3 = 0; _z3 < his_self.game.state.colonies.length; _z3++) {
        var c = his_self.game.state.colonies[_z3];
        var bonus_card = 0;
        if (c.destroyed != 1 && c.round <= round) {
          if (c.bonus_prize == 'bonus card') {
            bonus_card = 1;
          }
          if (c.prize == 'bonus card') {
            bonus_card = 1;
          }
          if (!c.prize) {
            c.prize = '-';
          }
          if (!c.modified_roll) {
            c.modified_roll = '-';
          }
          active_colonies++;
          his_self.app.browser.addElementToSelector(this.returnRowHTML({
            prize: c.prize,
            img: c.img,
            type: 'colony',
            name: c.name,
            faction: c.faction,
            total_hits: c.modified_roll,
            bonus_card: bonus_card
          }, stage), '.new-world-overlay .content .colonies');
        } else {
          if (c.destroyed == 1 && c.round_destroyed == round) {
            active_colonies++;
            var x = c.colony;
            if (his_self.game.state.newworld[x].claimed != 1) {
              his_self.app.browser.addElementToSelector(this.returnRowHTML({
                prize: c.name,
                img: c.img,
                type: 'colony',
                name: c.name,
                faction: 'abandoned',
                total_hits: c.modified_roll,
                depleted: 1,
                bonus_card: bonus_card
              }, stage), '.new-world-overlay .content .colonies');
            }
          }
        }
      }

      ///////////////
      // CONQUESTS //
      ///////////////
      for (var i = 0; i < his_self.game.state.conquests.length; i++) {
        var _c = his_self.game.state.conquests[i];
        var _bonus_card = 0;
        if (_c.bonus_prize == 'bonus card') {
          _bonus_card = 1;
        }
        if (!_c.prize) {
          _c.prize = '';
        }
        if (_c.round == round || _c.prize.indexOf('Aztec') > -1 || _c.prize.indexOf('Maya') > -1 || _c.prize.indexOf('Inca') > -1) {
          active_conquests++;
          //
          // conquest earns bonus card
          //
          if (_bonus_card == 1 && _c.depleted != 1) {
            his_self.app.browser.addElementToSelector(this.returnRowHTML({
              prize: _c.prize,
              img: _c.img,
              type: 'conquest',
              name: _c.prize,
              faction: _c.faction,
              conquistador: _c.conquistador,
              total_hits: _c.bonus_base_roll,
              depleted: 0,
              bonus_card: _bonus_card
            }, stage, true), '.new-world-overlay .content .conquests');
          } else {
            //
            // conquest depleted
            //
            if (_c.depleted) {
              his_self.app.browser.addElementToSelector(this.returnRowHTML({
                prize: _c.prize,
                img: _c.img,
                type: 'conquest',
                name: _c.prize,
                faction: 'depleted',
                conquistador: _c.conquistador,
                total_hits: _c.bonus_base_roll,
                depleted: 1,
                bonus_card: 0
              }, stage, false), '.new-world-overlay .content .conquests');
              //
              // conquest unproductive
              //
            } else {
              his_self.app.browser.addElementToSelector(this.returnRowHTML({
                prize: _c.prize,
                img: _c.img,
                type: 'conquest',
                name: _c.prize,
                faction: _c.faction,
                conquistador: _c.conquistador,
                total_hits: _c.modified_roll,
                depleted: 0,
                bonus_card: 0
              }, stage, false), '.new-world-overlay .content .conquests');
            }
          }
        }
      }

      //////////////////
      // EXPLORATIONS //
      //////////////////
      for (var _i = 0; _i < his_self.game.state.explorations.length; _i++) {
        var exp = his_self.game.state.explorations[_i];
        if (exp.round == round) {
          active_explorations++;
          his_self.app.browser.addElementToSelector(this.returnRowHTML({
            prize: exp.prize,
            img: exp.explorer_img,
            type: 'exploration',
            name: exp.name,
            faction: exp.faction,
            explorer: exp.explorer,
            total_hits: exp.modified_roll
          }, stage, false), '.new-world-overlay .content .explorations');
        }
      }
      console.log('active_explorations: ' + active_explorations);
      console.log('active_conquests: ' + active_conquests);
      console.log('active_colonies: ' + active_colonies);
      if (active_explorations == 0) {
        document.querySelector('.new-world-overlay .content .explorations').remove();
      }
      if (active_conquests == 0) {
        document.querySelector('.new-world-overlay .content .conquests').remove();
      }
      if (active_colonies == 0) {
        document.querySelector('.new-world-overlay .content .colonies').remove();
      }
      if (active_colonies == 0 && active_conquests == 0 && active_explorations == 0) {
        this.hide();
      }
    }
  }, {
    key: "returnRowHTML",
    value: function returnRowHTML() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var stage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var show_hits_as_goldenrod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (stage === 'results') {
        var img = '';
        var goldenrod = '';
        var total_hits = '?';
        var _row_css = '';
        var prize = obj.prize;
        if (prize == 'undefined' || prize == '') {
          prize = 'unsuccessful';
        }
        if (prize == undefined || prize == '') {
          prize = 'unsuccessful';
        }
        if (obj.img != '') {
          img = "background-image:url('".concat(obj.img, "')");
        }
        if (obj.total_hits != '') {
          total_hits = obj.total_hits;
        }
        if (obj.prize != '') {
          prize = obj.prize;
        }
        if (obj.depleted == 1) {
          _row_css += ' killed';
        }
        if (obj.killed == 1) {
          _row_css += ' killed';
        }
        if (prize.indexOf('killed') > -1) {
          _row_css += ' killed';
        }
        if (prize.indexOf('depleted') > -1) {
          _row_css += ' killed';
        }
        if (prize.indexOf('lost at sea') > -1) {
          _row_css += ' killed';
        }
        if (obj.bonus_card == 1) {
          goldenrod = 'goldenrod';
        }
        if (obj.goldenrod == 1) {
          goldenrod = 'goldenrod';
        }
        if (show_hits_as_goldenrod == false) {
          goldenrod = '';
        }
        return "\n\t    \t    <div class=\"new-world-row ".concat(_row_css, "\">\n            \t      <div class=\"new-world-explorer\" style=\"").concat(img, "\"></div>\n            \t      <div class=\"new-world-description\"><div class=\"new-world-details\">").concat(prize, "</div><div class=\"new-world-faction\">").concat(obj.faction, "</div></div>\n            \t      <div class=\"new-world-roll ").concat(goldenrod, "\">").concat(total_hits, "</div>\n            \t    </div>\n\t\t  ");
      } else {
        return "\n\t    \t    <div class=\"new-world-row ".concat(row_css, "\">\n            \t      <div class=\"new-world-explorer\">?</div>\n            \t      <div class=\"new-world-description\"><div class=\"new-world-details\">").concat(obj.type, "</div><div class=\"new-world-faction\">").concat(obj.faction, "</div></div>\n            \t      <div class=\"new-world-roll \">?</div>\n            \t    </div>\n\t\t  ");
      }
      return '';
    }
  }]);
}();
module.exports = NewWorldOverlay;